import React from 'react';
import { useAuthCheck } from '../utils/useAuthCheck';
import { useRouterProps } from '../hooks/useRouterProps';

/**
 * Simple private route guard - only checks authentication
 * Use this for routes that require authentication but no special permissions
 */
const PrivateRoute = ({ children, render, redirectTo, allowExpired = false, embed = false, ...props }) => {
    const routerProps = useRouterProps();
    const authRedirect = useAuthCheck({ requiresAuth: true, allowExpired, embed, redirectTo });

    // If auth check failed, return redirect
    if (authRedirect) {
        return authRedirect;
    }

    // Authenticated and not expired, render children
    return render ? render({ ...props, ...routerProps }) : children;
};

export default PrivateRoute;
